/**
 * Coarse geographic region hint sent on /chat/init. Shared by the built-in ChatWidget and the CDN
 * widget host transport so both land on the same value — the server feeds it to AgentRouter, so a
 * divergence here would route the two clients to different agents once region rules exist.
 */

/** Map IANA timezone to coarse geographic region hint for the API. */
export function deriveCoarseRegion(): string {
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone ?? '';
  if (tz.startsWith('America/')) return 'us';
  if (tz.startsWith('Europe/')) return 'eu';
  if (tz.startsWith('Asia/') || tz.startsWith('Australia/') || tz.startsWith('Pacific/')) return 'apac';
  return 'unknown';
}
